export const localStoreUser = 'language';
